import { Box, DialogContent, Stack } from "@mui/material";
import { FullScreenDialog } from "@src/appV2/lib/Dialogs/FullScreen/Dialog";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { HoldToConfirmButton } from "@src/appV2/redesign/components/HoldToConfirmButton";
import {
  Illustration,
  Text,
  Title,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

interface IncompleteBreakConfirmationDialogProps {
  modalState: UseModalState;
  professionalStatement: string;
  onContinue: () => void;
}

export function IncompleteBreakConfirmationDialog(props: IncompleteBreakConfirmationDialogProps) {
  const { modalState, professionalStatement, onContinue } = props;

  return (
    <FullScreenDialog modalState={modalState} variant="tertiary">
      <DialogContent sx={{ backgroundColor: (theme) => theme.palette.background.tertiary }}>
        <Stack spacing={4} direction="column" alignItems="center" my={4}>
          <Box pt={4}>
            <Illustration type="hours-limit" />
          </Box>
          <Title component="h1" sx={{ textAlign: "center" }}>
            Incomplete break
          </Title>
        </Stack>

        <Stack spacing={5} mt={5}>
          <Text>
            This timesheet contains an incomplete break. By signing this timesheet, you confirm the
            following statement from the Clipboard professional is true and accurate:
          </Text>

          <Text variant="body1" sx={{ fontStyle: "italic" }}>
            {professionalStatement}
          </Text>

          <Text>
            If this timesheet is signed, facility admin will be notified of the incomplete break and
            must approve or decline the break payment request.
          </Text>
        </Stack>
      </DialogContent>

      <DialogFooter
        withShadow
        orientation="vertical"
        sx={{ backgroundColor: (theme) => theme.palette.background.tertiary }}
        onClose={() => {
          modalState.closeModal();
        }}
      >
        <HoldToConfirmButton fullWidth size="large" isLoading={false} onConfirm={onContinue}>
          Press and hold to continue
        </HoldToConfirmButton>
      </DialogFooter>
    </FullScreenDialog>
  );
}
